<div class="ds-grid ds-grid--2">
	<!-- Editable Input -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Editable Input</h3>
			<p class="ds-example__header-subtitle">Can be modified</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				[label]="'Input Field'"
				[placeholder]="'Enter value'"
				[value]="inputValue"
				[fullWidth]="true"
				(valueChange)="onInputChange($event)">
			</eif-custom-input>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ inputValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Readonly Input -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Readonly Input</h3>
			<p class="ds-example__header-subtitle">Display only</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				[label]="'Input Field'"
				[placeholder]="'Enter value'"
				[value]="inputValue"
				[readonlyValue]="true"
				[fullWidth]="true">
			</eif-custom-input>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ inputValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Editable Select -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Editable Select</h3>
			<p class="ds-example__header-subtitle">Can be modified</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-select
				[label]="'Select Options'"
				[placeholder]="'Choose options'"
				[options]="options"
				[concatOptions]="true"
				[multiple]="true"
				[value]="selectedValue"
				[fullWidth]="true"
				(selectionChange)="onSelectionChange($event)">
			</eif-custom-select>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedValue?.join(', ') || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Readonly Select -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Readonly Select</h3>
			<p class="ds-example__header-subtitle">Display only</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-select
				[label]="'Select Options'"
				[placeholder]="'Choose options'"
				[options]="options"
				[concatOptions]="true"
				[multiple]="true"
				[value]="selectedValue"
				[readonlyValue]="true"
				[fullWidth]="true">
			</eif-custom-select>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedValue?.join(', ') || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Editable Checkbox -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Editable Checkbox</h3>
			<p class="ds-example__header-subtitle">Can be modified</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				[label]="'Accept Terms'"
				[checked]="checkboxValue"
				[checkedValue]="'Active'"
				[uncheckedValue]="'Inactive'"
				(checkedChange)="onCheckboxChange($event)">
			</eif-custom-checkbox>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ checkboxValue ? 'Active' : 'Inactive' }}</div>
			</div>
		</div>
	</div>

	<!-- Readonly Checkbox -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Readonly Checkbox</h3>
			<p class="ds-example__header-subtitle">Display only</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				[label]="'Accept Terms'"
				[checked]="checkboxValue"
				[checkedValue]="'Active'"
				[uncheckedValue]="'Inactive'"
				[readonlyValue]="true">
			</eif-custom-checkbox>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ checkboxValue ? 'Active' : 'Inactive' }}</div>
			</div>
		</div>
	</div>
</div>
